document.addEventListener('click', function (e) {
  const sortTitle = e.target.closest('[js-sort-title]');

  if (!sortTitle) return;

  console.log('ndikhshdki');

  sortTitle
    .closest('[js-select-sort-by]')
    ?.querySelector('[js-sort-by-filters]')
    ?.classList.toggle('active');
});

document.addEventListener('click', function (e) {
  const button = e.target.closest('.collection-filter-body [data-filter-dropdown-button]');

  if (!button) return;

  const currentContent = button
    .closest('.collection-filter-block')
    ?.querySelector('.collection-filter-options');

  document.querySelectorAll('.collection-filter-options').forEach((content) => {
    if (content !== currentContent) {
    //   content.classList.remove('active');
    }
  });

  currentContent?.classList.toggle('active');
  button?.classList.toggle('active');
});

document.addEventListener('click', function (e) {
  const filterToggler = e.target.closest('.filters-topbar-inner filter-toggler');

  if (!filterToggler) return;

  document
    .querySelector('.main-collection-wrapper')
    ?.classList.toggle('filters-open');
});
